import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isUndefined, values, isFunction, isBoolean, get } from 'lodash';
import { MDTApp } from '../../../../../../../actions/bootAction.js';
import constants from '../../../../../../../helpers/constants.js';
import { IconSet } from '../../../../../../atoms/mdt-iconset/index.js';
import MDTAnchor from '../../../../../../atoms/mdt-anchor/index.js';

const SubMenu = (props) => {
    const {
        t,
        data,
        pageName,
        meState,
        showSubMenu,
        setShowSubMenu,
        defaultApp,
        layoutConfig,
        selectedSubMenuName,
        items,
        sideBarOnClick,
        toggleMenu,
        menuOpen,
        setShowLevel0,
        checkAvailability,
        redirectToLink,
        closeMenu,
        privacyTermsLink,
    } = props;

    const name = pageName.toLowerCase();
    const exitportalId = get(layoutConfig, 'dashboard.id', '');
    const exitportalSubMenuId = get(layoutConfig, 'portal.id', '');
    const [level2MenuName, setLevel2MenuName] = useState('');
    const [level2Expanded, setLevel2Expanded] = useState(false);

    useEffect(() => {
        if (toggleMenu) {
            toggleMenu(false);
            window.innerWidth >= constants.DESKTOP_WIDTH &&
                !showSubMenu &&
                setLevel2Expanded(false);
            showSubMenu && setShowLevel0(false);
        }
    }, [showSubMenu]);

    useEffect(() => {
        !menuOpen && setLevel2Expanded(false);
    }, [menuOpen]);

    const isExitportalIconVisible = (menuItemId) => {
        if (
            defaultApp !== constants.PORTAL &&
            (menuItemId === exitportalId || menuItemId === exitportalSubMenuId)
        ) {
            return false;
        }
        return true;
    };

    const getlabelName = (label) => {
        return isFunction(label) ? label(meState) : t(label);
    };

    const checkUserType = (data) => {
        if (isUndefined(data)) {
            return true;
        }
        if (isBoolean(data)) {
            const { isInternalUser } = props;
            const isUserTypeValid = (isInternalUser && data) || (!isInternalUser && !data);
            return isUserTypeValid;
        }
        return false;
    };

    const isVisible = (visibility) => {
        if (typeof visibility === 'undefined') {
            return true;
        }
        if (typeof visibility === 'function') {
            return visibility(props.getResourceAccess, meState);
        }
        return visibility;
    };

    const onClickLevel2Handler = (label) => {
        level2MenuName === getlabelName(label)
            ? setLevel2Expanded(!level2Expanded)
            : setLevel2Expanded(true);
        if (window.innerWidth < constants.DESKTOP_WIDTH) setShowSubMenu(false);
        setLevel2MenuName(getlabelName(label));
    };

    const onLevel2Close = () => {
        setLevel2Expanded(false);
        setLevel2MenuName('');
        setShowSubMenu(true);
    };

    const onLevel1Close = () => {
        setShowSubMenu(false);
        setShowLevel0(true);
    };

    const subMenuName = showSubMenu && selectedSubMenuName === getlabelName(items.label);
    const openInNewWindow = privacyTermsLink?.configuration?.openInNewWindow;
    const privacyLink = privacyTermsLink?.configuration?.privacyLink;
    const renderSubItemLevel2 = (subItem, selectedSubMenuName) => {
        const items = values(subItem.submenu).map(
            (subItem, subIndex) =>
                checkUserType(subItem.isInternalUser) &&
                checkAvailability(subItem.available, subItem.roles, subItem.logicalOperation) &&
                isVisible(subItem.visible) &&
                isExitportalIconVisible(subItem.id) && (
                    <li
                        key={subIndex}
                        className={`mdtnavbar-item ${
                            subItem.mobileonly ? 'd-block d-sm-none d-md-none' : ''
                        } ${subItem.link && name === subItem.link.toLowerCase() ? ' active' : ''} ${
                            subItem.mobiletabletonly ? 'd-block d-sm-block d-md-none' : ''
                        }`}
                    >
                        {subItem.openInNewWindow && openInNewWindow ? (
                            <MDTAnchor
                                href={`${privacyLink}`}
                                target='_blank'
                                dataTest={subItem.dataTest}
                            >
                                <span className='label navLabel w-h-emphasis'>
                                    {getlabelName(subItem.label)}
                                </span>
                            </MDTAnchor>
                        ) : (
                            <MDTAnchor
                                href='#'
                                target={subItem.blank ? subItem.blank : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    sideBarOnClick(e, selectedSubMenuName, level2MenuName);
                                    if (subItem.link && !subItem.link.includes('javascript')) {
                                        closeMenu();
                                        redirectToLink(subItem.link, subItem.hash);
                                    } else if (subItem.onclick) {
                                        subItem.onclick(MDTApp, meState.meDetails);
                                    } else {
                                        toggleMenu(false, null);
                                    }
                                }}
                                dataTest={subItem.dataTest}
                            >
                                <span className='label navLabel w-h-emphasis'>
                                    {getlabelName(subItem.label)}
                                </span>
                            </MDTAnchor>
                        )}
                    </li>
                )
        );
        return (
            <>
                {level2MenuName === getlabelName(subItem.label) && (
                    <li className='mdtnavbar-item back d-block d-md-none'>
                        <IconSet name='arrow_left' className='expand-icon' />
                        <MDTAnchor
                            href='#'
                            className='label navLabel w-h-emphasis'
                            onClick={(e) => {
                                e.preventDefault();
                                onLevel2Close();
                            }}
                            dataTest='backButtonLink'
                        >
                            {level2MenuName}
                        </MDTAnchor>
                    </li>
                )}
                {items}
            </>
        );
    };

    return (
        <div>
            <ul className={subMenuName ? 'submenu expand' : 'submenu'}>
                <>
                    {selectedSubMenuName && (
                        <li className='mdtnavbar-item navLabel back d-block d-md-none'>
                            <IconSet name='arrow_left' className='expand-icon' />
                            <MDTAnchor
                                className='label w-h-emphasis'
                                href='#'
                                onClick={(e) => {
                                    e.preventDefault();
                                    onLevel1Close();
                                }}
                                dataTest='level1Close'
                            >
                                {selectedSubMenuName}
                            </MDTAnchor>
                        </li>
                    )}
                    {values(data).map(
                        (subItem, subIndex) =>
                            checkUserType(subItem.isInternalUser) &&
                            checkAvailability(
                                subItem.available,
                                subItem.roles,
                                subItem.logicalOperation
                            ) &&
                            isVisible(subItem.visible) &&
                            isExitportalIconVisible(subItem.id) && (
                                <li
                                    key={subIndex}
                                    className={`mdtnavbar-item ${
                                        subItem.mobileonly ? 'd-block d-sm-none d-md-none' : ''
                                    } ${
                                        subItem.link && name === subItem.link.toLowerCase()
                                            ? ' active'
                                            : ''
                                    } ${
                                        subItem.mobiletabletonly
                                            ? 'd-block d-sm-block d-md-none'
                                            : ''
                                    }`}
                                >
                                    {subItem.link ? (
                                        <MDTAnchor
                                            href='#'
                                            target={subItem.blank ? subItem.blank : ''}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                !subItem.submenu &&
                                                    sideBarOnClick(e, selectedSubMenuName);
                                                if (
                                                    subItem.link &&
                                                    !subItem.link.includes('javascript')
                                                ) {
                                                    closeMenu();
                                                    redirectToLink(subItem.link, subItem.hash);
                                                } else if (subItem.onclick) {
                                                    subItem.onclick(MDTApp, meState.meDetails);
                                                } else {
                                                    toggleMenu(false, null);
                                                }
                                            }}
                                            dataTest={subItem.dataTest}
                                        >
                                            <span className='label navLabel w-h-emphasis'>
                                                {getlabelName(subItem.label)}
                                            </span>
                                        </MDTAnchor>
                                    ) : (
                                        <ul
                                            className={`level2-parent ${
                                                level2Expanded &&
                                                level2MenuName === getlabelName(subItem.label)
                                                    ? 'expanded'
                                                    : ''
                                            } `}
                                        >
                                            <MDTAnchor
                                                href='#'
                                                className='label navLabel w-h-emphasis'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onClickLevel2Handler(subItem.label);
                                                }}
                                                dataTest={subItem.dataTest}
                                            >
                                                <>
                                                    {getlabelName(subItem.label)}
                                                    {subItem.submenu && (
                                                        <IconSet
                                                            name='arrow_right'
                                                            className='expand-icon'
                                                        />
                                                    )}
                                                </>
                                            </MDTAnchor>
                                            <div
                                                className={`menu-level2 ${
                                                    level2Expanded ? 'open' : ''
                                                }`}
                                            >
                                                {subItem.submenu &&
                                                    level2Expanded &&
                                                    level2MenuName ===
                                                        getlabelName(subItem.label) &&
                                                    renderSubItemLevel2(
                                                        subItem,
                                                        selectedSubMenuName
                                                    )}
                                            </div>
                                        </ul>
                                    )}
                                </li>
                            )
                    )}
                </>
            </ul>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        meState: state,
        pageName: state.location.type,
        pageType: get(state, 'page', ''),
        userId: get(state, 'meDetails.user.sub', null),
        isInternalUser: get(state, 'meDetails.isInternal', false),
        defaultApp: get(state, 'meDetails.user.defaultApp', null),
        privacyTermsLink: get(state, 'formConfig.featureConfiguration.PrivacyTermsLink', {}),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getResourceAccess: (resource, action) =>
            dispatch(MDTApp.getResourceAccess(resource, action)),
        languages: (lng) => dispatch(userInfoSucessLanguageUpdate(lng)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);
